// Configuration for API endpoints
import { normalizeApiBase } from './utils/apiUrl';

const apiBase = normalizeApiBase(process.env.REACT_APP_API_URL);
const uploadsBase =
  process.env.REACT_APP_UPLOADS_URL ||
  (apiBase.includes('onrender.com') ? apiBase : 'https://ecommerce-clothing-backend.onrender.com') ||
  apiBase;

const config = {
  API_BASE: apiBase,
  UPLOADS_BASE: uploadsBase,
  STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY || '',
  PAYPAL_CLIENT_ID: process.env.REACT_APP_PAYPAL_CLIENT_ID || '',
};

if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  console.log('[Bokeh config] API_BASE=', config.API_BASE, '| UPLOADS_BASE=', config.UPLOADS_BASE);
}

export default config;
